import React, { useRef } from 'react';
import cn from 'classnames';
import './style.scss';
import Button from 'shared/buttons';
import PDFViewer from 'shared/media/PDFViewer';
import Modal from 'shared/modals/Modal';
import { useOnClickOutside } from 'shared/../hooks';

const PreviewModal = ({
  onClose, previewFile, readOnly, onDelete,
}) => {
  const { name, fileType = '', urlForPreview } = previewFile ?? {};
  const isImage = fileType.includes('image') || fileType.includes('heic') || previewFile.name.toLowerCase().endsWith('.heic');

  // Close preview on click outside of the modal
  const previewRef = useRef();
  useOnClickOutside(previewRef, onClose);

  const showFooter = !readOnly && !!onDelete;
  const contentClassName = cn('file-preview-content', { 'has-footer': showFooter });

  return (
    <Modal isOpen containerStyle='large file-preview'>
      <div ref={previewRef} className={contentClassName}>
        <div className='file-preview-header'>
          <div className='file-preview-header'>
            <div className='file-preview-title'>{name}</div>
          </div>
          <Button
            icon='x'
            themeColor='secondary'
            fillMode='flat'
            onClick={onClose}
          />
        </div>
        {isImage && <img src={urlForPreview} alt='file-preview' />}
        {!isImage && <PDFViewer url={urlForPreview} />}
        {!readOnly && (
          <div className='file-preview-footer'>
            {onDelete && (
              <Button
                onClick={onDelete}
                themeColor='error'
                title='Delete'
                icon='delete'
              />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PreviewModal;
